import { render, staticRenderFns } from "./render-kwh-column-value.vue?vue&type=template&id=543e5ca6&scoped=true"
import script from "./render-kwh-column-value.vue?vue&type=script&lang=js"
export * from "./render-kwh-column-value.vue?vue&type=script&lang=js"
import style0 from "./render-kwh-column-value.vue?vue&type=style&index=0&id=543e5ca6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543e5ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543e5ca6')) {
      api.createRecord('543e5ca6', component.options)
    } else {
      api.reload('543e5ca6', component.options)
    }
    module.hot.accept("./render-kwh-column-value.vue?vue&type=template&id=543e5ca6&scoped=true", function () {
      api.rerender('543e5ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-kwh-column-value.vue"
export default component.exports